

















import STextarea from '@/common/components/STextarea.vue';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import AiLoadingOverlay from '@/tasks/components/AiLoadingOverlay.vue';

export default {
  name: 'OleMissL5PostLabPart5',
  components: {AiLoadingOverlay, STextarea},
  mixins: [DynamicQuestionMixin()],
  props: {
    isSubmitting: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      inputs: {
        part5_5: null,
      },
      questions: [
        {
          text: 'Sometimes you need to use someone else’s measurements or calculations. Do you trust the measurements that Humphrey took? Why or why not? Did this play a role in your determination of what material the piece of equipment was made from?',
          inputName: 'part5_5',
        },
      ],
    };
  },
};
